// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lvY_","colMin":"styles_colMin__2xvpq"};